/**
 * Simple in-memory cache for geocoding results
 * Prevents excessive API calls to geocoding service
 */

interface CacheEntry<T> {
    data: T;
    timestamp: number;
}

class GeocodingCache {
    private cache: Map<string, CacheEntry<any>> = new Map();
    private readonly TTL = 1000 * 60 * 60 * 24; // 24 hours

    set<T>(key: string, data: T): void {
        this.cache.set(key, {
            data,
            timestamp: Date.now(),
        });
    }

    get<T>(key: string): T | null {
        const entry = this.cache.get(key);

        if (!entry) {
            return null;
        }

        // Check if cache entry is still valid
        if (Date.now() - entry.timestamp > this.TTL) {
            this.cache.delete(key);
            return null;
        }

        return entry.data as T;
    }

    clear(): void {
        this.cache.clear();
    }

    size(): number {
        return this.cache.size;
    }
}

export const geocodingCache = new GeocodingCache();
